import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { ProductGraph } from 'state/product-description/model';
import styled from 'styled-components';
import { mediaQueryDown, mediaQueryEqualOrUpper } from 'utils/mediaQueries';

export interface BatchBlockNameColumnProps {
  productDescription: ProductGraph;
}

const StyledDiv = styled.div<{ $count: number }>`
  grid-row: span ${props => props.$count};
  ${mediaQueryDown('lg')`
    writing-mode: vertical-lr;
    padding-left: var(--spacer-2);
    padding-top: var(--spacer-3);
    font-size: 0.85rem;
  `};
  ${mediaQueryEqualOrUpper('lg')`
    padding-left: var(--spacer-3);
    padding-top: var(--spacer-2);
  `};
  max-width: 120px;
`;
export const BatchBlockNameColumn: FC<BatchBlockNameColumnProps> = ({ productDescription }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      {productDescription.map(
        ({ id, children }) =>
          children !== undefined && (
            <StyledDiv $count={children.length} className="with-border-bottom-thick" key={id}>
              <span className="text-uppercase text-wrap text-secondary fs-6">
                {formatMessage({ id: `batchPricer.block.${id}` as IntlKey })}
              </span>
            </StyledDiv>
          ),
      )}
    </>
  );
};

BatchBlockNameColumn.displayName = 'BatchBlockNameColumn';
